import { render } from "./ConfirmationTab.vue?vue&type=template&id=768fe3f0&ts=true"
import script from "./ConfirmationTab.vue?vue&type=script&lang=ts"
export * from "./ConfirmationTab.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__